import { useContext, useEffect } from 'react';
import {
  WorkflowEngineActionKind,
  WorkflowEngineContext
} from '../../WorkflowEngine/workflowEngineReducer';
import PageState from '../../Shared/pageState';
import { v4 as uuidv4 } from 'uuid';
import { useSnackbar } from 'notistack';
import ControlState from '../../Shared/controlState';
import ControlKind from '../../Shared/controlKind';
import isBuilding from '../../Shared/jsonSchemaUtilities/isBuilding';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { DragTypes } from '../../DragAndDrop';
import getLatestSchema from './schema';
import { Image as ImageIcon } from '@abbott-components/icons';
import Tooltip from '@mui/material/Tooltip';

export default () => {
  const { state, dispatch } = useContext(WorkflowEngineContext);

  const { pages } = state;

  const { enqueueSnackbar } = useSnackbar();

  const addControlToLastPage = (lastPage: PageState) => {
    const controlId = `control-${uuidv4()}`;
    const pageExternalId = lastPage.id;
    const order = Object.keys(lastPage.schema.properties as object).length - 1;
    const controlSchema = getLatestSchema(controlId, pageExternalId, order);

    dispatch({
      type: WorkflowEngineActionKind.CONTROL_ADD,
      payload: {
        id: controlId,
        building: true,
        pageId: lastPage.id,
        schema: controlSchema,
        kind: ControlKind.IMAGE
      } as ControlState
    });
  };

  const handleIconClick = () => {
    if (isBuilding(pages)) {
      enqueueSnackbar('One control can be built at a time.', {
        variant: 'warning'
      });
      return;
    }

    const lastPage = pages[pages.length - 1] as PageState;

    addControlToLastPage(lastPage);
  };

  const [, drag, preview] = useDrag(
    () => ({
      type: DragTypes.PALETTE_CONTROL,
      item: { type: ControlKind.IMAGE }
    }),
    []
  );

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, []);

  return (
      <Tooltip title="Image" placement="right" disableInteractive>
    <ListItemButton onClick={handleIconClick} ref={drag}>
      <ListItemIcon style={{ minWidth: 'auto' }}>
        <ImageIcon />
      </ListItemIcon>
    </ListItemButton>
    </Tooltip>
  );
};
